"use client"
import React, { forwardRef } from "react"
import {
  LineClampVariantProps,
  lineClampVariants,
} from "../../styles/utils/lineclamp"
import { classNames } from "../../utils"
import { Block, BlockProps } from "../Block"

export type TruncateProps = {
  children: React.ReactNode
  className?: string
  onOverflowedChange?: (overflowed: boolean) => void
} & LineClampVariantProps &
  BlockProps

export const Truncate = forwardRef<HTMLDivElement, TruncateProps>(
  function Truncate({ className, lines, ...rest }, ref) {
    return (
      <Block
        className={classNames(
          "max-w-full",
          !lines && "truncate",
          lineClampVariants({ lines }),
          className,
        )}
        ref={ref}
        {...rest}
      />
    )
  },
)
